import { Client } from '../../types';
import { ClientSchema } from '@/schemas/clientSchema';
import { doc, deleteDoc, getDocs, collection } from 'firebase/firestore';
import { safeWrite } from './coreService';

export const fetchClients = async (firestore: any): Promise<Client[]> => {
  const snap = await getDocs(collection(firestore, 'clients'));
  return snap.docs.map(d => ClientSchema.parse(d.data()));
};

export const addClient = async (firestore: any, client: Client) => {
  await safeWrite(doc(firestore, 'clients', client.id), client);
};

export const updateClient = async (firestore: any, client: Client) => {
  await safeWrite(doc(firestore, 'clients', client.id), client);
};

export const removeClient = async (firestore: any, id: string) => {
  await deleteDoc(doc(firestore, 'clients', id));
};
